import {theme} from '../../../theme';
import {Divider} from '../../atoms/Divider/Divider';
import {RecentSearchesProps} from './RecentSearchesProps.interface';

export function RecentSearches({children, ...props}: RecentSearchesProps) {
  return (
    <div {...props}>
      {children}
      <Divider
        color={theme.colors['theme-transparent-10']}
        className="mx-15pxr"
      />
    </div>
  );
}
